<template>
  <div class="regulationsContents hideScrollbar">
    <div v-for="(item,index) in regulationsContents.slice(1)" :key="index">
      <div :id="item.clause_code">
        <div v-if="item.clause_title" class="title">
          <div :class="[/^\u7b2c/.test(item.clause_title) == true ? 'titleTextCenter' : 'titleText']">
            {{item.clause_title}}
          </div>
        </div>
        <div v-else class="contents" v-html="$options.filters.addTextIndent(item)"> </div>
        <div v-if="item.clause_table" v-html="item.clause_table"></div>
        <div
          v-if="item.clause_table2"
          class="dev"
        >
          <table
            border="1"
            width=100%
            class="table"
            cellpadding="5"
          >
            <tr
              v-for="(item,index) in JSON.parse(item.clause_table2).children"
              :key="'d' + index"
            >
              <template v-for="(value,key,index) in item">
                <td
                  :key="'d_d'+index"
                  v-html='value.value'
                  :rowspan="value.rowspan != -1 ? value.rowspan : ''"
                  :colspan="value.colspan != -1 ? value.colspan : ''"
                  v-if="value.rowspan != '-1' && value.colspan != '-1'"
                  :class="value.head ? 'head' : ''"
                >
                </td>
              </template>
            </tr>
          </table>
        </div>
        <div v-if="item.clause_image">
          <div v-for="(itm,idx) in item.clause_image.split(',')" :key="idx" align="center">
            <img :src="'static/images/' + itm" type="image/svg+xml" class="image" :id="itm.substring(0,itm.length-4)"
              @click="showImage(itm.substring(0,itm.length-4))">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    count
  } from "@/misc/util.js";
  export default {
    props: {
      regulationsContents: Array
    },
    filters: {
      // par: 默认传过来的item.clause_contents
      addTextIndent(par) {
        // 按级别增加缩进
        var n = Math.max((count('-', par.clause_code) - count('-', par.clause_code2)) - (count('#', par.clause_code) -
          count('#', par.clause_code2)) - 2, 0)
        return ("<div style='text-indent:0.24rem;margin-left:" + 0.24 * n + "rem'>" + par.clause_contents + "</div>")
      }
    }
  }
</script>

<style scoped>
  .regulationsContents {
    height: calc(100vh - 1.5rem);
    margin-top: 0.2rem;
    padding-bottom: 0.2rem
  }

  .regulationsContents .title {
    margin-top: 0.24rem;
    font-weight: 900;
  }

  .regulationsContents .contents {
    margin-top: 0.12rem;
  }

  .regulationsContents .image {
    padding-top: 0.1rem;
    margin: 0 auto;
    width: 100%;
    max-width: 6rem;
    text-align: center;
  }

  .regulationsContents .titleText {
    font-weight: 900;
  }

  .regulationsContents .titleTextCenter {
    font-weight: 900;
    text-align: center
  }

  .dev {
    margin: 0.1rem;
    /* text-align: center; */
  }

  .table {
      border-collapse: collapse;
  }

  .table .head {
      font-weight: 900;
      text-align: center
  }
</style>